import { render, staticRenderFns } from "./TransporterDriverDetail.vue?vue&type=template&id=198c3490&"
import script from "./TransporterDriverDetail.vue?vue&type=script&lang=js&"
export * from "./TransporterDriverDetail.vue?vue&type=script&lang=js&"
import style0 from "./TransporterDriverDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports